interface HeartIconProps {
  filled?: boolean;
  className?: string;
}

export function HeartIcon({ filled = false, className = 'w-5 h-5' }: HeartIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={filled ? 0 : 1.75}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21s-6.716-4.35-9.428-8.28C.828 9.895 1.5 6 4.5 4.5 6.686 3.41 9 4 12 7c3-3 5.314-3.59 7.5-2.5 3 1.5 3.672 5.395 1.928 8.22C18.716 16.65 12 21 12 21z"
      />
    </svg>
  );
}
